var letterSpacing;

(function (letterSpacing) {
  letterSpacing["px_m_0p75"] = "-0.75px";
  letterSpacing[letterSpacing["px_0"] = 0] = "px_0";
  letterSpacing["px_0p25"] = "0.25px";
  letterSpacing["px_0p35"] = "0.35px";
  letterSpacing["px_1"] = "1px";
  letterSpacing["px_1p25"] = "1.25px";
})(letterSpacing || (letterSpacing = {}));

export default letterSpacing;